import { render, staticRenderFns } from "./NormalSearchNav140.vue?vue&type=template&id=1486b77b&scoped=true"
import script from "./NormalSearchNav140.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav140.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1486b77b",
  null
  
)

export default component.exports